module.exports = __webpack_public_path__ + "static/img/kitchener2.4f27b4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/kitchener2.jpg
// module id = 100
// module chunks = 9